var _title, _desc, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgUunnLogoWhite = function SvgUunnLogoWhite(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "38px",
    height: "38px",
    viewBox: "0 0 38 38",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "9BE12F31-4580-4E89-8A54-48F8208CE523")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home-Page-V10",
    transform: "translate(-130.000000, -21.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Nav-Transparent",
    transform: "translate(1.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "uunn_logo_white"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(129.000000, 21.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.7,17.3 C3.9,17.3 0,13.4 0,8.7 L0,1.2 C0,0.5 0.6,0 1.2,0 C1.8,0 2.4,0.5 2.4,1.2 L2.4,8.7 C2.4,12.2 5.2,15 8.7,15 C12.2,15 15,12.2 15,8.7 L15,1.2 C15,0.5 15.5,0 16.1,0 C16.8,0 17.3,0.5 17.3,1.2 L17.3,8.7 C17.3,13.4 13.4,17.3 8.7,17.3 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6,17.3 C23.8,17.3 19.9,13.4 19.9,8.6 L19.9,1.2 C19.9,0.5 20.4,0 21.1,0 C21.8,0 22.3,0.5 22.3,1.2 L22.3,8.7 C22.3,12.2 25.1,15 28.6,15 C32.1,15 34.9,12.2 34.9,8.7 L34.9,1.2 C34.8,0.5 35.4,0 36,0 C36.7,0 37.2,0.5 37.2,1.2 L37.2,8.7 C37.2,13.4 33.3,17.3 28.6,17.3 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36,37.1 C35.3,37.1 34.8,36.6 34.8,35.9 L34.8,28.4 C34.8,24.9 32,22.1 28.5,22.1 C25,22.1 22.2,24.9 22.2,28.4 L22.2,35.9 C22.2,36.6 21.7,37.1 21,37.1 C20.3,37.1 19.8,36.6 19.8,35.9 L19.8,28.4 C19.8,23.6 23.7,19.7 28.5,19.7 C33.3,19.7 37.2,23.6 37.2,28.4 L37.2,35.9 C37.2,36.6 36.7,37.1 36,37.1 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1,37.1 C15.4,37.1 14.9,36.6 14.9,35.9 L14.9,28.4 C14.9,24.9 12.1,22.1 8.6,22.1 C5.1,22.1 2.3,24.9 2.3,28.4 L2.3,35.9 C2.3,36.6 1.8,37.1 1.1,37.1 C0.4,37.1 0,36.6 0,35.9 L0,28.4 C0,23.6 3.9,19.7 8.7,19.7 C13.5,19.7 17.4,23.6 17.4,28.4 L17.4,35.9 C17.3,36.6 16.8,37.1 16.1,37.1 Z",
    id: "Path"
  }))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUunnLogoWhite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/uunn_logo_white.196d38bf.svg";
export { ForwardRef as ReactComponent };